/**
 * Filter fuer die Kurs-Collection im Studenten-Katalog. Aus CourseCatalog.tsx
 * ausgegliedert, damit der Regression-Test (#410) keine react-admin/MUI-
 * Dependencies mitzieht — CRA-Jest kann das ESM nicht transformieren.
 */
export function buildCatalogCourseFilter(companyId: number | null): Record<string, unknown> {
    const filter: Record<string, unknown> = {
        isActive: true,
        'catalog.isActive': true,
    };
    if (companyId) {
        filter.companyId = companyId;
    }

    return filter;
}
